import samuelRacicotOr from "../../../images/galery/mastermind_hawksbury_mars_2020/samuel_racicot_or.jpg";
import tommySambaultOr from "../../../images/galery/mma_amateur_automne_2019/tommy_sambault_or.jpg";
import lievArgent from "../../../images/galery/submission_art_united_17_fevrier_2024/liev_argent.jpg";
import anabelOr from "../../../images/galery/open_quebec_2_mars_2024/anabel_or.jpg";
import lievOr from "../../../images/galery/open_quebec_2_mars_2024/liev_or.jpg";
import teamOpenQuebec from "../../../images/galery/open_quebec_2_mars_2024/team.jpg";

import allMatsuruCup from "../../../images/galery/matsuru_cup_2_juin_2024/all.jpg";
import anabelOrMatsuruCup from "../../../images/galery/matsuru_cup_2_juin_2024/anabel_or_gi.jpg";
import andreiOrMatsuruCup from "../../../images/galery/matsuru_cup_2_juin_2024/andrei_or.jpg";
import linhBronzeGiMatsuruCup from "../../../images/galery/matsuru_cup_2_juin_2024/linh_bronze_gi.jpg";
import noGiFemmeMatsuruCup from "../../../images/galery/matsuru_cup_2_juin_2024/no_gi_femme.jpg";
import levSebCoachAdcc from "../../../images/galery/adcc_avril_2025/lev_seb_coach.jpg";
import levSebPodium from "../../../images/galery/adcc_avril_2025/podium_lev_seb.jpg";

import kimberlyArgentSau from "../../../images/galery/sau_21_juin_2025/kimberly_metcalf.jpeg";
import levSau from "../../../images/galery/sau_21_juin_2025/lev.jpeg";
import sebSau from "../../../images/galery/sau_21_juin_2025/seb.jpeg";

import kimberlyMedalsSau from "../../../images/galery/sau_14_fev_2026/kimberly_medals.jpeg";
import kimberlyPodiumSau from "../../../images/galery/sau_14_fev_2026/kimberly_podium.jpeg";

import kimberlyMedalsSauJuin2026 from "../../../images/galery/sau_20_juin_2026/kimberly_metcalf.jpeg";
import patrickBerteauSauJuin2026 from "../../../images/galery/sau_20_juin_2026/patrick_berteau.jpeg";

import groupMastermind from "../../../images/galery/mastermind_2026/group.jpeg";

import sebOntario from "../../../images/galery/int_ontario_2026/seb_bronze.jpeg";



export type CompetitionPhoto = {
  text: string;
  img: string;
  /** "gi" / "no-gi", omitted when the photo isn't tied to one format. */
  type?: string;
};

export type Competition = {
  lg: number;
  md: number;
  title: string;
  date: string;
  location: string;
  images: CompetitionPhoto[];
};

/** A photo flattened out of its competition, carrying that context along. */
export type GalleryPhoto = CompetitionPhoto & {
  competitionTitle: string;
  date: string;
  location: string;
};

const matsuruCup: Competition = {
  lg: 12,
  md: 12,
  title: "Matsuru Cup",
  date: "2 Juin 2024",
  location: "Longueuil, Québec",

  images: [
    {
      text: "Nos champions!",
      img: allMatsuruCup,
    },
    {
      text: "Anabel Becerra - médaille d'or",
      img: anabelOrMatsuruCup,
      type: "gi",
    },
    {
      text: "Andrei Popescu - médaille d'or",
      img: andreiOrMatsuruCup,
      type: "gi",
    },

    {
      text: "Khanh Linh Chu - médaille de bronze",
      img: linhBronzeGiMatsuruCup,
      type: "gi",
    },

    {
      text: "Anabel Becerra - argent, Linh - bronze",
      img: noGiFemmeMatsuruCup,
      type: "no-gi",
    },
  ],
};

const adccAvril2025: Competition = {
  lg: 8,
  md: 12,
  title: "ADCC",
  date: "19 Avril 2025",
  location: "Montréal, Québec",
  images: [
    {
      text: "Lev Kolbin or et Sebastian Manriquez argent",
      img: levSebPodium,
    },
    {
      text: "Lev et Seb avec coach Stephane",
      img: levSebCoachAdcc,
    },
  ],
};



const mastermindHawksburry: Competition = {
  lg: 4,
  md: 6,
  title: "Mastermind",
  date: "Mars 2020",
  location: "Hawksburry, Ontario",

  images: [
    {
      text: "Samuel Racicot - médaille d'or",
      img: samuelRacicotOr,
      type: "gi",
    },
  ],
};

const mmaAmateurAutomne2019: Competition = {
  lg: 4,
  md: 6,
  title: "MMA Amateur",
  date: "Automne 2019",
  location: "Montréal, Québec",

  images: [
    {
      text: "Tommy Sambault - médaille d'or",
      img: tommySambaultOr,
      type: "gi",
    },
  ],
};

const submissionArtUnited17Fevrier2024: Competition = {
  lg: 4,
  md: 6,
  title: "Submission Arts United",
  date: "17 Février 2024",
  location: "Montréal, Québec",

  images: [
    {
      text: "Lev Kolbin - médaille d'argent",
      img: lievArgent,
      type: "no-gi",
    },
  ],
};

const openQuebec2Mars2024: Competition = {
  lg: 12,
  md: 12,
  title: "Open Québec",
  date: "2 Mars 2024",
  location: "Montréal, Québec",

  images: [
    {
      text: "Anabel Becerra - médaille d'or",
      img: anabelOr,
      type: "gi",
    },
    {
      text: "Lev Kolbin - médaille d'or",
      img: lievOr,
      type: "no-gi",
    },
    {
      text: "Nos champions!",
      img: teamOpenQuebec,
    },
  ],
};

const sauJuin2025: Competition = {
  lg: 12,
  md: 12,

  title: "Submission Arts United",
  date: "21 Juin 2025",
  location: "Montréal, Québec",

  images: [
    {
      text: "Kimberly Metcalfe - médaille d'argent",
      img: kimberlyArgentSau,
      type: "no-gi",
    },
     {
      text: "Lev Kolbin - médaille de bronze",
      img: levSau,
      type: "gi",
    },
     {
      text: "Sebastian Manriquez -  médaille de bronze",
      img: sebSau,
      type: "gi",
    },
  ],
};

const sauFevrier2026: Competition = {
  lg: 8,
  md: 12,

  title: "Submission Arts United",
  date: "14 Février 2026",
  location: "Montréal, Québec",

  images: [
    {
      text: "Kimberly Metcalfe - Double médaillée d'or",
      img: kimberlyMedalsSau,
      type: "no-gi",
    },
    {
      text: "Kimberly Metcalfe - podium",
      img: kimberlyPodiumSau,
      type: "no-gi",
    },
  ],
};

const mastermindAvril2026: Competition = {
   lg: 4,
  md: 6,
  title: "Mastermind",
  date: "25 avril 2026",
  location: "Montréal, Québec",
  images: [
    {
      text: "Lev Kolbin argent absolute division et Kimberly Metcalfe or et argent",
      img: groupMastermind,
    },
   
  ],
};

const sauJuin2026: Competition = {
  lg: 8,
  md: 12,
  title: "SAU",
  date: "20 juin 2026",
  location: "Montréal, Québec",
  images: [
   {
      text: "Kimberly Metcalfe - Médaille d'argent ceinture bleue",
      img: kimberlyMedalsSauJuin2026,
      type: "no-gi",
    },
    {
      text: "Patrick Berteau - Juvenille médaille d'argent ceinture bleue",
      img: patrickBerteauSauJuin2026,
      type: "no-gi",
    },
   
  ],
};

const intOntario2026: Competition ={
  lg: 4,
  md: 6,
  title: "Ontario Open",
  date: "1er novembre 2026",
  location: "Whitby, Ontario",
  images: [
    {
      text: "Sebastian Manriquez - bronze ",
      img: sebOntario,
       type: "no-gi",
    },
   
  ],
}

export const COMPETITONS: Competition[] = [intOntario2026,sauJuin2026,
  mastermindAvril2026,
  sauFevrier2026,
  sauJuin2025,
  adccAvril2025,
  matsuruCup,
  openQuebec2Mars2024,
  submissionArtUnited17Fevrier2024,
  mastermindHawksburry,
  mmaAmateurAutomne2019,
];

export const ALL_PHOTOS: GalleryPhoto[] = COMPETITONS.flatMap((competition) =>
  competition.images.map((image) => ({
    ...image,
    competitionTitle: competition.title,
    date: competition.date,
    location: competition.location,
  }))
);
